var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { borderRadiusValues, boxShadowSizeValues, paletteFamilies, roundedValues, textStylesValues, } from '../../utils';
export var colors = __spreadArray(__spreadArray([''], paletteFamilies, true), ['NOTVALID'], false);
export var borderRadii = __spreadArray(__spreadArray([''], borderRadiusValues, true), ['NOTVALID'], false);
export var rounded = __spreadArray(__spreadArray([''], roundedValues, true), ['NOTVALID'], false);
export var shadows = __spreadArray(__spreadArray([''], boxShadowSizeValues, true), ['NOTVALID'], false);
export var textStyles = __spreadArray(__spreadArray([''], textStylesValues, true), ['NOTVALID'], false);
export var inputArgs = ['sm', 'md', 'lg', 'xl'];
export var spaceArgs = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
].reduce(function (acc, prop) {
    acc[prop] = {
        name: prop,
        type: { name: 'string' },
        description: prop,
        table: {
            disable: true,
        },
    };
    return acc;
}, {});
export var fontSizes = [0, 1, 2, 3, 4, 5, 6, 7, 8];
//# sourceMappingURL=index.js.map